import React, { FC } from 'react';
import { PageHeader } from 'antd';
import styles from './styles.less';

type BlockProps = {
  children?: React.ReactNode;
  title?: string;
  subTitle?: React.ReactNode;
  extra?: React.ReactNode;
};

export const Block: FC<BlockProps> = ({ children, title, subTitle, extra }) => {
  const className = styles['specialization-block'];

  return (
    <PageHeader
      ghost={false}
      title={title}
      subTitle={subTitle}
      extra={extra}
      className={className}
    >
      {children}
    </PageHeader>
  );
};
